import React from "react";
import "./App.css";
import MainPhoto from "./assets/MainPhoto.jpg";
import PilatesReformer from "./assets/Reformer.jpg";
import Studio from "./assets/Le_studio.jpg";
import Seperation from "./assets/Speration.jpg";
import ReserveButton from "./components/ReserveButton";
import InstagramTest from "./components/./InstagramTest";
import InstaPlugWidget from "./components/InstaPlugWidget";
import PlanningSchedule from "./components/PlanningSchedule";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Logo from "./assets/Sans_Fond_Caro 1.svg";
import { useRef } from "react";

function App() {
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -400, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 400, behavior: "smooth" });
  };

  return (
    <Router>
      <Routes>
        <Route path="/instagram-test" element={<InstagramTest />} />
        {/* Add your homepage or other routes here */}
        <Route
          path="/"
          element={
            <div className="pilates-app">
              <div className="hero-section">
                <img src={MainPhoto} alt="Main" className="hero-image" />
                <img src={Logo} alt="Logo" className="hero-logo" />

                <div className="hero-button-wrapper">
                  <ReserveButton />
                </div>
              </div>

              <div className="info-section">
                <div className="studio-section">
                  <img
                    src={Studio}
                    alt="Studio Imperial Pilates à Ajaccio"
                    className="studio-image"
                  />
                  <div className="studio-text-content">
                    <h2 className="section-title">LE STUDIO</h2>
                    <div className="studio-text-wrapper">
                      <div className="studio-paragraph">
                        Situé au 71 cours Napoléon, notre studio de 110 m² a été
                        pensé pour allier bien-être, confort et performance. Un
                        espace lumineux, climatisé et entièrement équipé vous
                        accueille du lundi au samedi de 7h30 à 20h, et le
                        dimanche sur réservation.
                      </div>
                      <div className="studio-paragraph">
                        Notre studio se compose de deux salles dédiées à la
                        pratique du Pilates :
                      </div>

                      <ul className="studio-list">
                        <li>
                          Une salle machines équipée de 6 reformers et d'un
                          Cadillac
                        </li>
                        <li>
                          Une salle Pilates au sol avec 6 tapis pour les
                          séances en petit groupe
                        </li>
                      </ul>

                      <div className="studio-paragraph">
                        Vous trouverez également :
                      </div>

                      <ul className="studio-list">
                        <li>Un vestiaire confortable</li>
                        <li>Une salle de bain avec deux douches séparées</li>
                        <li>Deux toilettes</li>
                        <li>
                          Une salle de bien-être dédiée aux soins : drainage
                          lymphatique corps et visage, palper-rouler
                        </li>
                        <li>
                          Café : café, thé, latte, matcha latte, ube latte, eaux
                          aromatisées et jus de fruits frais
                        </li>
                      </ul>

                      <div className="studio-paragraph">
                        Tous nos cours sont encadrés par des professeurs
                        diplômés par la Fédération des Professionnels de la
                        Méthode Pilates (FPMP), pour vous garantir un
                        accompagnement de qualité !
                      </div>
                    </div>
                  </div>
                </div>

                <div className="reformer-section">
                  <div className="reformer-text-content">
                    <h2 className="section-title">Le pilates Reformer</h2>
                    <p className="reformer-description">
                      Le Pilates va renforcer le corps en profondeur, tout en
                      cultivant le contrôle, l'alignement et la fluidité du
                      mouvement. Le Reformer vient sublimer cette pratique en
                      ajoutant résistance et précision grâce aux ressorts et
                      poulies de la machine. Chaque exercice engage les muscles
                      profonds, améliore la posture, travaille la coordination,
                      l'équilibre et la respiration. Accessible à tous les
                      niveaux, tous les âges et tous les corps, le Pilates
                      Reformer est à la fois doux pour les articulations et
                      redoutablement efficace pour le renforcement musculaire.
                      C'est l'alliance parfaite entre exigence technique,
                      élégance du geste et bien-être global. Des fessiers qui
                      bossent, des abdos qui chauffent, un corps qui s'aligne et
                      une posture qui s'élève. Des cours variés, encadrés par
                      des coachs passionnés et formés qui ne laissent aucun
                      muscle en paix (mais toujours avec bienveillance !).
                    </p>
                  </div>
                  <img
                    src={PilatesReformer}
                    alt="Studio Imperial Pilates à Ajaccio"
                    className="reformer-image"
                  />
                </div>
              </div>

              <div className="courses-section">
                <div className="courses-content">
                  <h2 className="main-title">LES COURS</h2>

                  <div className="course-item">
                    <h3 className="course-title">Basics Pilates</h3>
                    <div className="course-divider">
                      <div className="divider-line"></div>
                    </div>
                    <p className="course-description">
                      Ton point de départ pour adopter le Reformer ! Ici, on
                      pose les bases : contrôle, respiration, posture,
                      engagement du centre et coordination. Parfait pour les
                      débutant·es ou pour revenir aux fondamentaux. Tu vas
                      apprendre à bouger autrement… et ton corps va adorer.
                    </p>
                  </div>

                  <div className="course-item">
                    <h3 className="course-title">Booty &amp; Core</h3>
                    <div className="course-divider">
                      <div className="divider-line"></div>
                    </div>
                    <p className="course-description">
                      C'est LE combo qui fait sensation : fessiers galbés, abdos
                      gainés, posture parfaite et une séance qui chauffe comme
                      il faut. Focus sur le bas du corps et la sangle
                      abdominale, avec des mouvements précis, dynamiques et
                      efficaces.
                    </p>
                  </div>

                  <div className="course-item">
                    <h3 className="course-title">Full Body</h3>
                    <div className="course-divider">
                      <div className="divider-line"></div>
                    </div>
                    <p className="course-description">
                      Un entraînement complet qui fait travailler tout, vraiment
                      tout. Haut, bas, centre, dos, équilibre, respiration,
                      coordination… rien n'est laissé au hasard. L'objectif : un
                      corps fort et harmonieux.
                    </p>
                  </div>

                  <div className="course-item">
                    <h3 className="course-title">Reform Me Up</h3>
                    <div className="course-divider">
                      <div className="divider-line"></div>
                    </div>
                    <p className="course-description">
                      Notre cours signature pour celles et ceux qui veulent
                      envoyer du flow ! Rythmé, créatif, challengeant, ce cours
                      fait monter le cardio tout en respectant la technique. Tu
                      vas ressortir transpirant·e et accro dès la première
                      séance.
                    </p>
                  </div>

                  <div className="course-item">
                    <h3 className="course-title">Reformen</h3>
                    <div className="course-divider">
                      <div className="divider-line"></div>
                    </div>
                    <p className="course-description">
                      Un cours pensé pour vous messieurs, avec un vrai focus sur
                      la force, la mobilité et l'équilibre. Moins de blabla,
                      plus de résultats : du gainage, du renfo, du vrai Pilates,
                      version tonique. Spoiler : tu vas bosser des muscles que
                      tu ne savais même pas que tu avais.
                    </p>
                  </div>

                  <div className="course-item">
                    <h3 className="course-title">Jumpboard</h3>
                    <div className="course-divider">
                      <div className="divider-line"></div>
                    </div>
                    <p className="course-description">
                      Envie d’un entraînement qui combine énergie, fluidité et fun ? Le Jumpboard sur Reformer est fait pour toi.
                      Grâce à cette planche fixée au Reformer, chaque séance devient plus dynamique : tu « sautes » allongé, sans impact sur les articulations, tout en sollicitant intensément tes muscles profonds.
                      Ce cours unique allie <strong>cardio, renforcement et coordination</strong> dans un format ludique et ultra efficace. On alterne des séquences dynamiques avec des moments de contrôle, pour sculpter le corps, améliorer l’endurance et booster la mobilité.
                    </p>
                  </div>

                  <div className="course-item sweat">
                    <h3 className="course-title">Sweat & Stretch</h3>
                    <div className="course-divider">
                      <div className="divider-line"></div>
                    </div>
                    <p className="course-description">
                      Un cours qui allie intelligemment la méthode Pilates, le
                      travail musculaire en profondeur et des phases d’étirement
                      ciblées, le tout dans une ambiance dynamique et fluide.
                      Ici, on bouge, on transpire, on s’étire. Chaque séance est
                      pensée pour activer votre corps en douceur mais
                      intensément, améliorer votre posture, tonifier vos muscles
                      profonds, et relâcher les tensions grâce à des étirements
                      guidés. Le rythme est soutenu mais accessible, idéal pour
                      se renforcer tout en prenant soin de sa mobilité. Parfait
                      pour celles et ceux qui veulent travailler, respirer et
                      relâcher dans un même cours. Vous sortirez de la séance à
                      la fois énergisé·e et détendu·e.
                    </p>
                  </div>
                </div>
              </div>

              <PlanningSchedule />

              <div className="photos-section">
                <img
                  src={Seperation}
                  alt="Studio Imperial Pilates à Ajaccio"
                  className="gallery-image"
                />
              </div>

              <div className="pricing-section">
                <h2 className="pricing-main-title">Les TARIFS</h2>

                <div className="pricing-content">
                  <h3 className="pricing-category-title">Pilates Reformer</h3>

                  <div className="pricing-cards" ref={scrollRef}>
                    <div className="pricing-card">
                      <h4 className="card-title">Decouverte</h4>
                      <div className="card-content">
                        <p className="card-price">
                          <span>3 cours d'essais : 60 €</span>
                          <br />
                          <span>(Au lieu de 84 €)</span>
                        </p>
                      </div>
                      <div className="reserve-button-wrapper">
                        <ReserveButton
                          onClick={() =>
                            window
                              .open(
                                "https://backoffice.bsport.io/m/IMPERIAL%20PILATES%20CLUB/4150/pass/?tabSelected=3&index=3",
                                "_blank",
                              )
                              .focus()
                          }
                        />
                      </div>
                    </div>

                    <div className="pricing-card">
                      <h4 className="card-title">ABonements</h4>
                      <div className="card-content">
                        <p className="card-price">2 cours / mois : 50 €</p>
                        <p className="card-price">4 cours / mois : 95 €</p>
                        <p className="card-price">8 cours / mois : 180 €</p>
                        <p className="card-price">10 cours / mois : 200 €</p>
                        <p className="card-price">Accès illimité : 350 € ***</p>
                      </div>
                      <div className="reserve-button-wrapper">
                        <ReserveButton
                          onClick={() =>
                            window
                              .open(
                                "https://backoffice.bsport.io/m/IMPERIAL%20PILATES%20CLUB/4150/subscription/?tabSelected=5&index=5",
                                "_blank",
                              )
                              .focus()
                          }
                        />
                      </div>
                    </div>

                    <div className="pricing-card">
                      <h4 className="card-title">Solo</h4>
                      <div className="card-content">
                        <p className="card-price">Cours à l'unité : 60 € *</p>
                        <p className="card-price">Carnet 5 cours : 280 € **</p>
                        <p className="card-price">Carnet 10 cours : 540 € **</p>
                      </div>
                      <div className="reserve-button-wrapper">
                        <ReserveButton
                          onClick={() =>
                            window
                              .open(
                                "https://backoffice.bsport.io/m/IMPERIAL%20PILATES%20CLUB/4150/pass/?tabSelected=3&index=3",
                                "_blank",
                              )
                              .focus()
                          }
                        />
                      </div>
                    </div>

                    <div className="pricing-card">
                      <h4 className="card-title">Duo</h4>
                      <div className="card-content">
                        <p className="card-price">Cours à l'unité : 45 € *</p>
                        <p className="card-price">Carnet 5 cours : 210 € **</p>
                        <p className="card-price">Carnet 10 cours : 430 € **</p>
                      </div>
                      <div className="reserve-button-wrapper">
                        <ReserveButton
                          onClick={() =>
                            window
                              .open(
                                "https://backoffice.bsport.io/m/IMPERIAL%20PILATES%20CLUB/4150/pass/?tabSelected=3&index=3",
                                "_blank",
                              )
                              .focus()
                          }
                        />
                      </div>
                    </div>

                    <div className="pricing-card">
                      <h4 className="card-title">TRIO</h4>
                      <div className="card-content">
                        <p className="card-price">Cours à l'unité : 40 € *</p>
                        <p className="card-price">Carnet 5 cours : 190 € **</p>
                        <p className="card-price">Carnet 10 cours : 370 € **</p>
                      </div>
                      <div className="reserve-button-wrapper">
                        <ReserveButton
                          onClick={() =>
                            window
                              .open(
                                "https://backoffice.bsport.io/m/IMPERIAL%20PILATES%20CLUB/4150/pass/?tabSelected=3&index=3",
                                "_blank",
                              )
                              .focus()
                          }
                        />
                      </div>
                    </div>

                    <div className="pricing-card">
                      <h4 className="card-title">Collectifs</h4>
                      <div className="card-content">
                        <p className="card-price">Cours à l'unité : 28 € *</p>
                        <p className="card-price">Carnet 5 cours : 130 € **</p>
                        <p className="card-price">Carnet 10 cours : 250 € **</p>
                      </div>
                      <div className="reserve-button-wrapper">
                        <ReserveButton
                          onClick={() =>
                            window
                              .open(
                                "https://backoffice.bsport.io/m/IMPERIAL%20PILATES%20CLUB/4150/pass/?tabSelected=3&index=3",
                                "_blank",
                              )
                              .focus()
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="pricing-navigation">
                    <div className="nav-arrows">
                      <div className="arrow-left" onClick={scrollLeft}>
                        <svg
                          width="50"
                          height="50"
                          viewBox="0 0 50 50"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M25 50C38.7846 50 50 38.7846 50 25C50 11.2154 38.7846 0 25 0C11.2154 0 0 11.2154 0 25C0 38.7846 11.2154 50 25 50ZM25 46.1538C13.2942 46.1538 3.84615 36.7058 3.84615 25C3.84615 13.2942 13.2942 3.84615 25 3.84615C36.7058 3.84615 46.1538 13.2942 46.1538 25C46.1538 36.7058 36.7058 46.1538 25 46.1538ZM23.6154 37.3192L26.3846 34.6154L18.6923 26.9231L38.4615 26.9231V25V23.0769L18.6923 23.0769L26.3846 15.3846L23.6154 12.6808L12.6808 23.6173L11.2962 25.0019L12.6808 26.3865L23.6173 37.3212L23.6154 37.3192Z"
                            fill="#958977"
                          />
                        </svg>
                      </div>
                      <div className="arrow-right" onClick={scrollRight}>
                        <svg
                          width="50"
                          height="50"
                          viewBox="0 0 50 50"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M25 0C11.2154 0 0 11.2154 0 25C0 38.7846 11.2154 50 25 50C38.7846 50 50 38.7846 50 25C50 11.2154 38.7846 0 25 0ZM25 3.84615C36.7058 3.84615 46.1538 13.2942 46.1538 25C46.1538 36.7058 36.7058 46.1538 25 46.1538C13.2942 46.1538 3.84615 36.7058 3.84615 25C3.84615 13.2942 13.2942 3.84615 25 3.84615ZM26.3846 12.6808L23.6154 15.3846L31.3077 23.0769H11.5385V25V26.9231H31.3077L23.6154 34.6154L26.3846 37.3192L37.3192 26.3827L38.7038 24.9981L37.3192 23.6135L26.3827 12.6788L26.3846 12.6808Z"
                            fill="#958977"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="pilates-floor-section">
                  <h3 className="pricing-category-title">Pilates au sol</h3>

                  <div className="floor-pricing-cards">
                    <div className="pricing-card">
                      <h4 className="card-title">Abonnement</h4>
                      <div className="card-content">
                        <p className="card-price">
                          Accès illimité : 120 € / mois
                        </p>
                      </div>
                      <div className="reserve-button-wrapper">
                        <ReserveButton
                          onClick={() =>
                            window
                              .open(
                                "https://backoffice.bsport.io/m/IMPERIAL%20PILATES%20CLUB/4150/subscription/?tabSelected=5&index=5",
                                "_blank",
                              )
                              .focus()
                          }
                        />
                      </div>
                    </div>

                    <div className="pricing-card">
                      <h4 className="card-title">Carnets</h4>
                      <div className="card-content">
                        <p className="card-price">Cours à l'unité : 18 €</p>
                        <p className="card-price">
                          Carnet 10 cours : 160 € ****
                        </p>
                      </div>
                      <div className="reserve-button-wrapper">
                        <ReserveButton
                          onClick={() =>
                            window
                              .open(
                                "https://backoffice.bsport.io/m/IMPERIAL%20PILATES%20CLUB/4150/pass/?tabSelected=3&index=3",
                                "_blank",
                              )
                              .focus()
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="pricing-disclaimer">
                  <p className="disclaimer-text">
                    <span>
                      *Prix par personne **Carnets Reformer valables 3 mois pour
                      les 5 cours et 6 mois pour les 10 cours.
                    </span>
                    <br />
                    <span>
                      *** Accès illimité Reformer comprend Reformer + pilates au
                      sol
                    </span>
                    <br />
                    <span>**** Valable 3 mois</span>
                  </p>
                </div>
              </div>

              <div className="footer-section">
                <div className="instagram-section">
                  <div className="instagram-content">
                    <h2 className="instagram-title">NOtre instagram</h2>
                    <InstaPlugWidget />
                  </div>
                </div>

                <div className="contact-section">
                  <div className="contact-info">
                    <div className="contact-group">
                      <h3 className="contact-heading">Contacts</h3>
                      <a
                        href="mailto:imperialpilates.ajaccio@gmail.com"
                        className="contact-email"
                      >
                        imperialpilates.ajaccio@gmail.com
                      </a>
                      <a href="tel:+33613530116" className="contact-phone">
                        +33 6 13 53 01 16
                      </a>
                    </div>
                    <div className="address-group">
                      <h3 className="contact-heading">Adresse</h3>
                      <a
                        href="https://www.google.com/maps?q=71+cours+Napoléon,+20000+Ajaccio"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="contact-address"
                      >
                        71 cours Napoléon, 20000 Ajaccio
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
